import {Platform} from 'react-native';

const webBaseUrl = process.env.REACT_APP_API_URL || 'https://lk-api.eskso.ru/HPA/API/1_0/';
const mobileBaseUrl = process.env.REACT_APP_API_URL || 'https://lk-api.eskso.ru/MobileApp/API/1_0/';
const webProxyUrl = process.env.REACT_APP_WEB_PROXY_URL || 'https://lk.eskso.ru';

export const settings = {
  baseUrl: Platform.OS === 'web' ? webBaseUrl : mobileBaseUrl,
  webProxyUrl: webProxyUrl,
};
